import { render, staticRenderFns } from "./SelectFile.vue?vue&type=template&id=0554472a&"
import script from "./SelectFile.vue?vue&type=script&lang=js&"
export * from "./SelectFile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports